import { handleNewError } from "./errorInteractions";
import {
  ding,
  formatAMPM,
  getNonce,
  getNotificationData,
  getOpenCloseLongFuturePrice,
  getOpenCloseLongOptionPrice,
  getOptionPrice,
  hasTxFailed,
  onConfirmed,
  onError,
  onFailed,
  onPending
} from "../../utils/utils.js";
import {
  addFailedTransactionNotification,
  addPendingTransactionNotification,
  confirmTransactionNotification,
  marketCreated,
  marketsLoaded,
  marketUpdated,
  marketPricesUpdated,
  marginAccountDataLoaded,
  marginPoolDataLoaded,
  underlyingTokenPriceLoaded
} from "../actions/actions.js";
import { formatUnits } from "@ethersproject/units";
import { fromSqrtPrice, getMaxLongAmountWhenSellingOptions, insert, MarketHelper } from "../../utils/MarketHelper";
import { handleNewNotification } from "./notificationInteractions";
import { Contract } from "@ethersproject/contracts";
import { store } from "../configureStore";
import { addPositionToken, loadUnderlyingMarketPrice, updateUnderlyingMarketPrice } from "./tokensInteractions";
import moment from "moment";
import { setIntervalAsync } from "set-interval-async/fixed";
import { get } from "lodash";
import { loadMarginAccountData, loadMarginAccountData2, loadMarginPoolData, loadMarginPoolData2 } from "./marginInteractions.js";
import { batch } from "react-redux";

// TODO: v2 make this configurable (for example last 8 months)
let loadMarketsFromBlockFilter = 0;
export const TEN_TO_EIGHTEEN = 10 ** 18;
let periodicalMarketBasePricesUpdater;
const TEN_SECONDS = 10000;

export const subscribeToMarketFactoryEvents = async (provider, riskFreeRate, web3, marketFactory, loadHelper, userBalances, userAddress, dispatch) => {
  try {
    const abi = [
      "event MarketCreated(uint40 indexed marketId, bytes32 indexed marketHash, uint40 longTokenId, uint40 shortTokenId, bool isCall, uint128 strikePrice, uint32 expirationTime, address baseTokenAddress, address underlyingTokenAddress)",
      "event MultipleMarketsCreated(uint16 marketCount)"
    ];
    const marketFactoryContract = new Contract(marketFactory._address, abi, provider);

    marketFactoryContract.on(
      "MarketCreated",
      async (marketId, marketHash, longTokenId, shortTokenId, isCall, strikePrice, expirationTime, baseTokenAddress, underlyingTokenAddress, event) => {
        const marketAttributes = {
          marketId,
          marketHash,
          isCall,
          strikePrice,
          expirationTime,
          baseTokenAddress,
          underlyingTokenAddress
        };
        // console.log("Received MarketCreated event: ", marketAttributes);
        addNewMarket(riskFreeRate, web3, marketAttributes, loadHelper, userBalances, dispatch);
      }
    );

    // marketFactoryContract.on("MultipleMarketsCreated", async (marketCount, event) => {
    //   let eventNonce;
    //   await web3.eth.getTransactionCount(userAddress, (err, nonce) => {
    //     if (!err) {
    //       eventNonce = nonce;
    //     } else {
    //       console.error(err);
    //     }
    //   });
    //   console.log("nonce: ", eventNonce);

    //   const marketText = marketCount > 1 ? "markets" : "market";

    //   const timestamp = parseInt((new Date().getTime() / 1000).toFixed(0));

    //   const notification = {
    //     quantity: `Creating ${marketCount} ${marketText}`,
    //     tx: event.transactionHash,
    //     timestamp,
    //     status: "confirmed",
    //     nonce: eventNonce
    //   };
    //   dispatch(confirmTransactionNotification(notification, userAddress));
    //   ding();
    // });
  } catch (e) {
    console.log(e);
    handleNewError({}, "Error while loading data. Please reset your account and reload the application!", 1, dispatch, true);
  }
};

export const loadMarkets = async (loadHelper, riskFreeRate, web3, marketFactory, userBalances, underPriceBN, dispatch) => {
  try {
    console.log("Call blockchain - getPastEvents: MarketCreated");
    let startTime = new Date();
    const createdMarketStream = await marketFactory.getPastEvents("MarketCreated", {
      fromBlock: loadMarketsFromBlockFilter,
      toBlock: "latest"
    });
    console.log("load getPastEvents:MarketCreated in: " + (new Date() - startTime) + " ms");
    const createdMarketEvents = createdMarketStream.map(event => event.returnValues);
    let marketIds = createdMarketEvents.map(event => event.marketId);
    const timestampNow = Math.round(new Date().getTime() / 1000);
    const result = await loadHelper.methods.getMarketData(marketIds, userBalances._address, timestampNow).call();
    const marketSingletonData = result[0];
    const marketData = result[1];
    console.log("Call blockchain - loadHelper.getMarketData in " + (new Date() - startTime) + " ms");
    marketIds = marketIds.filter(id => Number(id) < 1000000000); //we sent on blockchain only market ids that are not futures
    console.log("Call blockchain - loadHelper.getMarketPrices", underPriceBN.toString());
    let marketPrices = await loadHelper.methods.getMarketPrices(marketIds, underPriceBN, timestampNow).call();
    const nonFuturemarketPricesMap = new Map();
    marketPrices.forEach((marketPrice, i) => {
      nonFuturemarketPricesMap.set(marketIds[i], marketPrice);
    });

    const markets = marketData.map((market, i) => {
      let { marketId, isCall, strikePrice, expirationTime, baseTokenAddress, underlyingTokenAddress } = createdMarketEvents[i];

      const isFuture = strikePrice.toString() === (10 ** 12).toString();
      const normalizedStrikePrice = parseFloat(formatUnits(strikePrice.toString(), 18));
      const underPrice = parseFloat(formatUnits(marketSingletonData.underPriceInBase.toString(), 18));
      const volatility = parseFloat(formatUnits(market.longPriceInVol.toString(), 18));

      // const longPriceInBase = isFuture ? underPrice : getOptionPrice(riskFreeRate, expirationTime, normalizedStrikePrice, isCall, underPrice, volatility);
      const longPriceInBase = isFuture ? underPrice : parseFloat((nonFuturemarketPricesMap.get(marketId).priceInBase / 10 ** 18).toString());

      // calculate open and close prices
      let { openLongPrice, closeLongPrice } = isFuture
        ? getOpenCloseLongFuturePrice(longPriceInBase, expirationTime)
        : getOpenCloseLongOptionPrice(
            longPriceInBase,
            underPrice,
            expirationTime,
            marketSingletonData.maxFee,
            marketSingletonData.minFee,
            marketSingletonData.steepness
          );

      // market helper
      let helper = new MarketHelper(0, parseInt(market.belowTick), Math.sqrt(volatility), expirationTime, normalizedStrikePrice, isCall, riskFreeRate);
      if (isFuture) {
        // delete zero tick if future
        helper.ticks = [];
        helper.currentSqrtPrice = Math.sqrt(underPrice);
      }
      for (let tick of market.ticks) {
        const tickLiquidity = parseFloat(formatUnits(tick.liquidity.toString(), isFuture ? 12 : 18));
        insert(helper, { index: parseInt(tick.index), liquidity: tickLiquidity });
      }

      const currentLiquidity = parseFloat(formatUnits(market.liquidity.toString(), isFuture ? 12 : 18));
      helper.currentLiquidity = currentLiquidity;

      // oracle prices
      const lowerOraclePriceInVol = fromSqrtPrice(market.oracleData.lowerLimitSqrtPrice.toString());
      const upperOraclePriceInVol = fromSqrtPrice(market.oracleData.upperLimitSqrtPrice.toString());
      const currentOraclePriceInVol = lowerOraclePriceInVol * Math.sqrt(upperOraclePriceInVol / lowerOraclePriceInVol);
      const oracle = {
        lowerPriceInVol: lowerOraclePriceInVol,
        currentPriceInVol: currentOraclePriceInVol,
        upperPriceInVol: upperOraclePriceInVol
      };

      const optionsPoolBalance = getMaxLongAmountWhenSellingOptions(helper).toString();

      const requiredThreshold = marketSingletonData.requiredThresholdOption;
      const liquidationThreshold = marketSingletonData.liquidationThresholdOption;

      return {
        immutableAttributes: {
          marketId: marketId.toString(),
          isCall: isCall,
          strikePrice: strikePrice.toString(),
          expirationTime: expirationTime,
          baseTokenAddress: baseTokenAddress,
          baseTokenDecimals: 18,
          underlyingTokenAddress: underlyingTokenAddress,
          isFuture: isFuture
        },
        // variable
        mutableAttributes: {
          marketId: marketId.toString(),
          longPriceInVol: volatility.toString(),
          longPrice: longPriceInBase.toString(),
          openLongPrice: openLongPrice.toString(),
          closeLongPrice: closeLongPrice.toString(),
          openShortPrice: [closeLongPrice.toString(), isCall ? TEN_TO_EIGHTEEN : strikePrice],
          closeShortPrice: [openLongPrice.toString(), isCall ? TEN_TO_EIGHTEEN : strikePrice],
          isSettled: market.isSettled,
          openInterest: market.openInterest.toString(),
          minFee: marketSingletonData.minFee.toString(),
          maxFee: marketSingletonData.maxFee.toString(),
          steepness: marketSingletonData.steepness.toString(),
          requiredThreshold: requiredThreshold.toString(),
          liquidationThreshold: liquidationThreshold.toString(),
          penaltyBase: marketSingletonData.penaltyBase.toString(),
          isEmpty: false, // todo: what is this used for? contract returned false always
          optionsPoolBalance: optionsPoolBalance,
          marketHelper: helper,
          liquidityInCurrentTick: market.liquidity,
          priceOracle: oracle
        }
      };
    });
    // dispatch(
    //   marketsLoaded(
    //     markets.map(market => market.immutableAttributes),
    //     markets.map(market => market.mutableAttributes)
    //   )
    // );

    return markets;
  } catch (e) {
    console.log(e);
    handleNewError({}, "Error while loading markets. Please reload the application!", 1, dispatch);
  }
};

export const addNewMarket = async (riskFreeRate, web3, marketAttributes, loadHelper, userBalances, dispatch) => {
  try {
    let { marketId, isCall, strikePrice, expirationTime, baseTokenAddress, underlyingTokenAddress } = marketAttributes;

    // fetch data from contracts
    const isFuture = strikePrice.toString() === (10 ** 12).toString();
    const immutableMarketAttributes = {
      marketId: marketId.toString(),
      isCall: isCall,
      strikePrice: strikePrice.toString(),
      expirationTime: expirationTime,
      baseTokenAddress: baseTokenAddress,
      baseTokenDecimals: 18,
      underlyingTokenAddress: underlyingTokenAddress,
      isFuture: isFuture
    };

    const mutableMarketAttributes = await getMuttableMarketAttributes(loadHelper, userBalances, marketId, immutableMarketAttributes, riskFreeRate);

    dispatch(marketCreated(immutableMarketAttributes, mutableMarketAttributes));
    addPositionToken(web3, marketId.toString(), "long", immutableMarketAttributes, dispatch);
    addPositionToken(web3, (parseInt(marketId) + 1).toString(), "short", immutableMarketAttributes, dispatch);
  } catch (e) {
    console.log(e);
    handleNewError({}, "Error while fetching market data. Please reload the application!", 1, dispatch);
  }
};

export const updateMarket = async (riskFreeRate, web3, marketId, dispatch) => {
  try {
    const { loadHelper, userBalances } = store.getState().contracts.data;
    const { marketsImmutable } = store.getState();
    const marketImmutableData = marketsImmutable.data.find(market => market.marketId === marketId.toString());
    let { isCall, strikePrice, expirationTime } = marketImmutableData;
    const normalizedStrikePrice = parseFloat(formatUnits(strikePrice.toString(), 18));

    const mutableMarketAttributes = await getMuttableMarketAttributes(loadHelper, userBalances, marketId, marketImmutableData, riskFreeRate);

    dispatch(marketUpdated(mutableMarketAttributes));

    return getTokenNames(isCall, normalizedStrikePrice, expirationTime);
  } catch (e) {
    console.log(e);
    handleNewError({}, "Error while fetching market data. Please reload the application!", 1, dispatch);
  }
};

export const getMuttableMarketAttributes = async (loadHelper, userBalances, marketId, immutableMarketAttributes, riskFreeRate) => {
  let { isCall, strikePrice, expirationTime } = immutableMarketAttributes;
  const timestampNow = Math.round(new Date().getTime() / 1000);
  const result = await loadHelper.methods.getMarketData([marketId], userBalances._address, timestampNow).call();
  const marketSingletonData = result[0];
  const marketData = result[1];
  const isFuture = strikePrice.toString() === (10 ** 12).toString();
  const normalizedStrikePrice = parseFloat(formatUnits(strikePrice.toString(), 18));
  const underPrice = parseFloat(formatUnits(marketSingletonData.underPriceInBase.toString(), 18));
  const longPriceInVol = parseFloat(formatUnits(marketData[0].longPriceInVol.toString(), 18));
  const longPriceInBase = isFuture ? underPrice : getOptionPrice(riskFreeRate, expirationTime, normalizedStrikePrice, isCall, underPrice, longPriceInVol);

  // calculate open and close prices
  let { openLongPrice, closeLongPrice } = isFuture
    ? getOpenCloseLongFuturePrice(longPriceInBase, expirationTime)
    : getOpenCloseLongOptionPrice(
        longPriceInBase,
        underPrice,
        expirationTime,
        marketSingletonData.maxFee,
        marketSingletonData.minFee,
        marketSingletonData.steepness
      );

  let helper = new MarketHelper(0, parseInt(marketData[0].belowTick), Math.sqrt(longPriceInVol), expirationTime, normalizedStrikePrice, isCall, riskFreeRate);
  if (isFuture) {
    // delete zero tick if future
    helper.ticks = [];
    helper.currentSqrtPrice = Math.sqrt(underPrice);
  }
  helper.ticks = marketData[0].ticks.map(tick => {
    return { index: Number(tick.index), liquidity: parseFloat(formatUnits(tick.liquidity.toString(), 18)) };
  });

  const currentLiquidity = parseFloat(formatUnits(marketData[0].liquidity.toString(), isFuture ? 12 : 18));
  helper.currentLiquidity = currentLiquidity;

  const lowerOraclePriceInVol = fromSqrtPrice(marketData[0].oracleData.lowerLimitSqrtPrice);
  const upperOraclePriceInVol = fromSqrtPrice(marketData[0].oracleData.upperLimitSqrtPrice);
  const currentOraclePriceInVol = lowerOraclePriceInVol * Math.sqrt(upperOraclePriceInVol / lowerOraclePriceInVol);
  const oracle = {
    lowerPriceInVol: lowerOraclePriceInVol,
    currentPriceInVol: currentOraclePriceInVol,
    upperPriceInVol: upperOraclePriceInVol
  };

  const requiredThreshold = marketSingletonData.requiredThresholdOption;
  const liquidationThreshold = marketSingletonData.liquidationThresholdOption;
  const optionsPoolBalance = getMaxLongAmountWhenSellingOptions(helper).toString();
  const openInterest = marketData[0].openInterest;

  const mutableMarketAttributes = {
    marketId: marketId.toString(),
    longPriceInVol: longPriceInVol.toString(),
    longPrice: longPriceInBase.toString(),
    openLongPrice: openLongPrice.toString(),
    closeLongPrice: closeLongPrice.toString(),
    openShortPrice: [closeLongPrice.toString(), isCall ? TEN_TO_EIGHTEEN : strikePrice],
    closeShortPrice: [openLongPrice.toString(), isCall ? TEN_TO_EIGHTEEN : strikePrice],
    // historicalData: { loaded: false, data: [] },
    isSettled: marketData[0].isSettled,
    openInterest: openInterest,
    optionsPoolBalance: optionsPoolBalance,
    minFee: marketSingletonData.minFee.toString(),
    maxFee: marketSingletonData.maxFee.toString(),
    steepness: marketSingletonData.steepness.toString(),
    requiredThreshold: requiredThreshold.toString(),
    liquidationThreshold: liquidationThreshold.toString(),
    penaltyBase: marketSingletonData.penaltyBase.toString(),
    isEmpty: false,
    marketHelper: helper,
    liquidityInCurrentTick: marketData[0].liquidity,
    priceOracle: oracle
  };
  return mutableMarketAttributes;
};

export const getTokenNames = (isCall, strikePrice, expirationTime) => {
  const isFuture = strikePrice === 0.000001;
  const dateStr = moment(new Date(expirationTime * 1000))
    .format("DDMMMYY")
    .toString()
    .toUpperCase();
  if (isFuture) {
    const longNameAndSymbol = "LONG-ETH-" + dateStr + "-FUTURE-USD";
    const shortNameAndSymbol = "SHORT-ETH-" + dateStr + "-FUTURE-USD";

    return { longTokenName: longNameAndSymbol, shortTokenName: shortNameAndSymbol };
  }

  const strikeStr = strikePrice.toString();
  const isCallStr = isCall ? "C" : "P";

  const longNameAndSymbol = "LONG-ETH-" + dateStr + "-" + strikeStr + "-" + isCallStr + "-USD";
  const shortNameAndSymbol = "SHORT-ETH-" + dateStr + "-" + strikeStr + "-" + isCallStr + "-USD";

  return { longTokenName: longNameAndSymbol, shortTokenName: shortNameAndSymbol };
};

// const onPending = (hash, userAccount, text, transactionNonce, timestamp, closeModal, dispatch) => {
//   // const timestamp = parseInt((new Date().getTime() / 1000).toFixed(0));
//   const notificationData = getNotificationData(text, hash, timestamp, "pending", transactionNonce);
//   dispatch(addPendingTransactionNotification(notificationData, userAccount));
//   closeModal && closeModal();
//   ding();
// };

// const onFailed = (hash, userAccount, text, transactionNonce, timestamp, dispatch) => {
//   // const timestamp = parseInt((new Date().getTime() / 1000).toFixed(0));

//   const notificationData = getNotificationData(text, hash, timestamp, "failed", transactionNonce);
//   handleNewError(null, "Transaction failed!", 2, dispatch);
//   dispatch(addFailedTransactionNotification(notificationData, userAccount));

//   // todo: there should be different ding for failed tx
//   ding();
// };

// const onConfirmed = (hash, userAccount, text, transactionNonce, timestamp, dispatch) => {
//   // const timestamp = parseInt((new Date().getTime() / 1000).toFixed(0));

//   const notificationData = getNotificationData(text, hash, timestamp, "confirmed", transactionNonce);
//   dispatch(confirmTransactionNotification(notificationData, userAccount));

//   ding();
// };

// const onError = (e, message, dispatch) => {
//   console.log(e);
//   if (e.code === 4001) {
//     handleNewNotification("Transaction rejected.", 2, dispatch);
//   } else {
//     handleNewError(e, message, 1, dispatch);
//   }
// };

const multipleMarketsNotificationText = length => {
  const marketText = length > 1 ? "markets" : "market";
  return "Creating " + length + " " + marketText;
};

export const createMultipleMarkets = async (
  web3,
  account,
  marketFactory,
  isCalls,
  strikePrices,
  expirationTime,
  baseTokenAddress,
  underlyingTokenAddress,
  closeModal,
  dispatch
) => {
  try {
    const notificationText = multipleMarketsNotificationText(isCalls.length);
    const txNonce = await getNonce(web3, account);
    const contractMethod = marketFactory.methods.createMultipleMarkets(isCalls, strikePrices, expirationTime, baseTokenAddress, underlyingTokenAddress);
    const limitGas = Math.round((await contractMethod.estimateGas({ from: account })) * 1.2); // 20% extra gas
    console.log("Estimated gas: " + limitGas);
    const timestamp = parseInt((new Date().getTime() / 1000).toFixed(0));
    let isConfirmed = false;
    await contractMethod
      .send({ from: account, gas: limitGas })
      .on("transactionHash", async function(hash) {
        onPending(hash, account, notificationText, txNonce + 1, timestamp, closeModal, dispatch);
        const hasFailed = await hasTxFailed(web3, hash);
        if (hasFailed) {
          onFailed(hash, account, notificationText, txNonce + 1, timestamp, dispatch);
        }
      })
      .on("confirmation", function(confirmationNumber, receipt) {
        if (!isConfirmed) {
          if (receipt.status) {
            onConfirmed(receipt.transactionHash, account, notificationText, txNonce + 1, timestamp, dispatch);
          } else {
            onFailed(receipt.transactionHash, account, notificationText, txNonce + 1, timestamp, dispatch);
          }
          isConfirmed = true;
        }
      });
  } catch (e) {
    onError(e, "Error while creating new market!", dispatch);
  }
};

export const periodicallyUpdateMarketBasePrices = async (loadHelper, gammaContractsRegistry, userBalances, marginPool, userAccount, dispatch) => {
  try {
    // start fetching periodically if not already started
    if (periodicalMarketBasePricesUpdater == null) {
      //console.log("Starting market base prices periodical fetcher..");
      // periodicalMarketBasePricesUpdater = setIntervalAsync(async () => {
      periodicalMarketBasePricesUpdater = setInterval(async () => {
        try {
          // NOTE: we can't update under without updating option and future prices, so it's all in one updater
          const { tokenPairs, marketsImmutable, marketsMutable } = store.getState();
          if (tokenPairs.loaded && marketsImmutable.loaded && marketsMutable.loaded) {
            // step 1) get under price
            const { newUnderPrice, newAvgUnderPrice } = await loadUnderlyingMarketPrice(loadHelper, dispatch);

            // step 2) fire loading of margin data
            const marginAccountData = await loadMarginAccountData2(
              userAccount,
              loadHelper,
              marginPool,
              userBalances,
              newAvgUnderPrice,
              gammaContractsRegistry,
              dispatch
            );
            const marginPoolData = await loadMarginPoolData2(loadHelper, marginPool, newAvgUnderPrice, gammaContractsRegistry, dispatch);

            // step 3) get market prices
            let marketIds = marketsImmutable.data.map(m => m.marketId);
            const timestampNow = Math.round(new Date().getTime() / 1000);

            if (marketIds && newAvgUnderPrice) {
              console.log("Call blockchain - loadHelper.getMarketPrices");
              let futureMarketIds = marketIds.filter(id => Number(id) >= 1000000000);
              marketIds = marketIds.filter(id => Number(id) < 1000000000); //we sent on blockchain only market ids that are not futures
              let marketPrices = await loadHelper.methods.getMarketPrices(marketIds, newAvgUnderPrice, timestampNow).call();
              const marketPricesForFutures = futureMarketIds.map(id => {
                return {
                  priceInBase: newAvgUnderPrice
                };
              });
              marketIds = [...futureMarketIds, ...marketIds];
              marketPrices = [...marketPricesForFutures, ...marketPrices];

              // repack
              let markets = [];
              for (let i = 0; i < marketIds.length; i++) {
                const longPriceInBase = (marketPrices[i].priceInBase / 10 ** 18).toString();
                const avgUnderPrice = newAvgUnderPrice / 10 ** 18;
                const marketMuttable = marketsMutable.data.find(m => m.marketId === marketIds[i]);
                const marketImuttable = marketsImmutable.data.find(m => m.marketId === marketIds[i]);

                // const longPriceInBase = isFuture ? underPrice : getOptionPrice(riskFreeRate, expirationTime, normalizedStrikePrice, isCall, underPrice, longPriceInVol);
                let { openLongPrice, closeLongPrice } = marketImuttable.isFuture
                  ? getOpenCloseLongFuturePrice(avgUnderPrice, marketImuttable.expirationTime)
                  : getOpenCloseLongOptionPrice(
                      parseFloat(longPriceInBase),
                      avgUnderPrice,
                      marketImuttable.expirationTime,
                      marketMuttable.maxFee,
                      marketMuttable.minFee,
                      marketMuttable.steepness
                    );

                // oracle prices
                const isFuture = Number(marketIds[i]) >= 1000000000;
                let oracle = null;
                if (!isFuture) {
                  const lowerOraclePriceInVol = fromSqrtPrice(marketPrices[i].oracleData.lowerLimitSqrtPrice.toString());
                  const upperOraclePriceInVol = fromSqrtPrice(marketPrices[i].oracleData.upperLimitSqrtPrice.toString());
                  const currentOraclePriceInVol = lowerOraclePriceInVol * Math.sqrt(upperOraclePriceInVol / lowerOraclePriceInVol);
                  oracle = {
                    lowerPriceInVol: lowerOraclePriceInVol,
                    currentPriceInVol: currentOraclePriceInVol,
                    upperPriceInVol: upperOraclePriceInVol
                  };
                }

                markets.push({
                  marketId: marketIds[i],
                  longPrice: longPriceInBase,
                  openLongPrice: openLongPrice.toString(),
                  closeLongPrice: closeLongPrice.toString(),
                  openShortPrice: [closeLongPrice.toString(), marketImuttable.isCall ? 10 ** 18 : marketImuttable.strikePrice],
                  closeShortPrice: [openLongPrice.toString(), marketImuttable.isCall ? 10 ** 18 : marketImuttable.strikePrice],
                  priceOracle: !isFuture ? oracle : null
                });
              }

              batch(() => {
                const pair = tokenPairs.data[0];
                if (newUnderPrice != null && newAvgUnderPrice != null) {
                  // update state if price changed
                  if (pair.underlyingTokenPrice !== newUnderPrice || pair.avgUnderlyingTokenPrice !== newAvgUnderPrice) {
                    dispatch(underlyingTokenPriceLoaded(pair, newUnderPrice, newAvgUnderPrice));
                  }
                }
                dispatch(marketPricesUpdated(markets));
                dispatch(marginAccountDataLoaded(marginAccountData));
                dispatch(marginPoolDataLoaded(marginPoolData));
              });
            }
          }
        } catch (e) {
          console.log(e);
          handleNewError({}, "Error while fetching market prices. Please reload the application!", 1, dispatch);
        }
      }, TEN_SECONDS);
    }
  } catch (e) {
    handleNewError(e, "There was an error with periodical fetcher!", 2, dispatch);
  }
};
